import React from 'react';

export function Spinner({ className = 'h-5 w-5' }) {
  return (
    <span
      className={`inline-block animate-spin rounded-full border-2 border-ink/10 border-t-pop border-r-primary ${className}`}
      role="status"
      aria-label="Loading"
    />
  );
}

export function PageLoader({ label = 'Loading…' }) {
  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-4 text-muted" role="status" aria-live="polite">
      <span className="relative grid h-14 w-14 place-items-center">
        <span className="absolute inset-0 animate-ping rounded-2xl bg-primary/15" />
        <span className="relative grid h-12 w-12 place-items-center rounded-2xl bg-navy shadow-glow-blue">
          <svg viewBox="0 0 32 32" className="h-6 w-6" aria-hidden="true">
            <circle cx="13" cy="13" r="7" fill="none" stroke="rgb(var(--c-sun))" strokeWidth="3.5" />
            <path d="M18.5 18.5 25 25" stroke="rgb(var(--c-pop))" strokeWidth="4" strokeLinecap="round" />
          </svg>
        </span>
      </span>
      <span className="font-display text-sm font-semibold tracking-wide">{label}</span>
    </div>
  );
}

export default Spinner;
